import BookingSection from "@/components/booking-section"
import BranchGridContainer from "@/components/branch-grid-container"
import AnnouncementSection from "@/components/announcement-section"
import { useTab } from "@/hooks/useTab"
import { ArrowLeft } from "lucide-react"
import { Link } from "react-router-dom"
import { useEffect, Suspense } from "react"
import { useTranslation } from "react-i18next"
import { useSearchParamsCompat } from "@/lib/router-helpers"
import OrganizationSkeleton from "@/components/organization-skeleton"

function DarsContent() {
  const { t } = useTranslation();
  const {activeTab} = useTab()
  const [searchParams] = useSearchParamsCompat()
  const mode = searchParams.get("mode")

    useEffect(() => {
    window.localStorage.setItem("qetero.bookingTab", activeTab)
  }, [])

  const backLink = mode === "reschedule" ? "/booking/history" : "/"
  
  return (
    <div className="md:pb-20 pb-10">
      <AnnouncementSection />
      <BookingSection/>
      <BranchGridContainer />
       <div 
        className="flex justify-start mt-1 md:mt-8  px-3"
      >
        <Link 
          to={backLink}
          className="group px-8 h-12 flex items-center gap-2 rounded-full border border-gray-200 bg-white text-gray-900 text-sm font-semibold hover:border-pink-500 hover:text-pink-600 transition-all duration-300 shadow-sm hover:shadow-md active:scale-95"
        >
          <ArrowLeft className="w-4 h-4 transition-transform group-hover:-translate-x-1" />
          {t("back")}
        </Link>
      </div>
    </div>
  )
}

export default function OrganizationDarsPage() {
  return (
    <Suspense fallback={<OrganizationSkeleton />}>
      <DarsContent />
    </Suspense>
  )
}
